export default __webpack_public_path__ + "static/media/maya-angelou.16800f8c.png";